module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAM1BMVEX///8cICSNj5FUV1rGx8iOkJJVWFt+gYMpLTDi4+PU1dXw8fGpq6w3Oz5GSk1jZmhxdHb4AI98AAAAeklEQVQoka2Q0QrCMBAE927X5JImrf//tbaooG2EKs7DkDBwFwJs5Lz3A3JvoFxTShHp3UsBg2RsenUkmI9Gud3DYfkzHPg90EzrZT3LjGdClSYUqWCS6pnw/Y6Pz23uBXIXins7MyqTFY1sqOT/PzHmy4C5Q90GdN0AgfwEgkLmI9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlt.png
// module id = 209
// module chunks = 1